var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { SummaryButtons as Wrapper } from "@irati-web/reward/src/components/styled";
export var GreyBackground = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  padding: 30px;\n  margin: 0 -20px -20px;\n  ", "\n"], ["\n  ", "\n  padding: 30px;\n  margin: 0 -20px -20px;\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return "background-color: " + theme.colors.greys.lightest + ";";
}, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.minWidthMedia.tablet(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: 30px 45px;\n    margin: 0 -45px 20px;\n  "], ["\n    padding: 30px 45px;\n    margin: 0 -45px 20px;\n  "])));
});
export var SummaryButtons = styled(Wrapper)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-top: 40px;\n"], ["\n  margin-top: 40px;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
